import { EMAIL_VALIDATOR } from "helpers/validators";

export const signInFields = {
  Email: {
    fieldKey: "Email",
    element: "input",
    type: "email",
    title: "Email",
    placeholder: "login-user-email-placeholder",
    label: "login-user-email-label",
    validation: {
      required: true,
      invalidMessage: "invalid-email-text",
      reg: EMAIL_VALIDATOR,
    },
  },
  Password: {
    fieldKey: "Password",
    element: "input",
    type: "password",
    title: "Password",
    placeholder: "login-password-placeholder",
    label: "login-password-label",
    hidePassStrength: true,
  },
  Remember: {
    fieldKey: "Remember",
    element: "checkbox",
    title: "Remember",
    label: "login-remember-label",
  },
  ForgotPassword: {
    fieldKey: "ForgotPassword",
    element: "text",
    title: "ForgotPassword",
    label: "forgot-password-text",
    linkData: { old: false, page: "password-recover" },
  },
};

export default signInFields;
